import $ from 'jquery';
import pym from 'pym.js';

// Pym handles automatic iframe heigh adjustment for embeds on our website.  Only divs with ID #fc-interactive will be handled by pym
export default function () {
    var pymChild;
    $(function () {
        if ($('#fc-interactive').length) {
            // Replace iframe embeds from FC related widgets to use pym to resize
            $('#fc-interactive').each(function () {
                var $this = $(this);
                var embedSource = $this.data('src');
                var appendClass = $this.data('appendclass');
                $this.addClass(appendClass);
                $('.page-inner').addClass('fc-interactive');
                $this.html('<span id="fc-interactive-loading" style="font-size:24px; text-align: center">Loading...</span>');

                pymChild = new pym.Parent('fc-interactive', embedSource, {});
                $(pymChild.iframe).load(function () {
                    $('#fc-interactive-loading').remove();
                });
            });
        }
    });
}
